import(/* webpackMode: "eager" */ "/root/frontend/app/error.tsx");
